import React from 'react';

export const ReturningPolicy: React.FC = () => {
  return (
    <div className='mx-auto mt-4 w-full space-y-6 lg:mt-8 lg:max-w-3xl'>
      <div className='w-full space-y-3'>
        <h6 className='text-lg font-semibold'>
          Các trường hợp <strong>ĐƯỢC</strong> trả lại hàng hóa
        </h6>
        <div className='flex flex-col border border-hl-beige lg:flex-row'>
          <div className='flex w-full shrink-0 flex-col items-center justify-center border-hl-beige p-4 lg:w-fit lg:border-r'>
            <i className='block h-16 w-16'>
              <svg
                data-slot='icon'
                fill='none'
                strokeWidth='1.5'
                stroke='currentColor'
                viewBox='0 0 24 24'
                xmlns='http://www.w3.org/2000/svg'
                aria-hidden='true'
                className='h-full w-full'
              >
                <path
                  strokeLinecap='round'
                  strokeLinejoin='round'
                  d='m15.75 10.5 4.72-4.72a.75.75 0 0 1 1.28.53v11.38a.75.75 0 0 1-1.28.53l-4.72-4.72M4.5 18.75h9a2.25 2.25 0 0 0 2.25-2.25v-9a2.25 2.25 0 0 0-2.25-2.25h-9A2.25 2.25 0 0 0 2.25 7.5v9a2.25 2.25 0 0 0 2.25 2.25Z'
                ></path>
              </svg>
            </i>
            <span className='text-lg font-bold text-hl-secondary'>(Có video khui hàng)</span>
          </div>
          <ul className='flex-1 list-inside'>
            <li className='list-decimal border-t border-hl-beige p-4 lg:border-t-0'>
              Những sản phẩm lỗi kết cấu sản phẩm do quá trình sản xuất của hãng.
            </li>
            <li className='list-decimal border-t border-hl-beige p-4'>
              Lỗi do vận chuyển dẫn đến việc sản phẩm bị méo mó, thay đổi hình dạng, hư hỏng, bị nứt, vỡ.
            </li>
          </ul>
        </div>
      </div>

      <div className='w-full space-y-3'>
        <h6 className='text-lg font-semibold'>
          Các trường <strong>KHÔNG ĐƯỢC</strong> chấp nhận trả lại hàng hóa
        </h6>
        <ul className='list-inside border border-hl-beige'>
          <li className='list-decimal border-hl-beige p-4 lg:border-t-0'>
            Sản phẩm bị tác động từ phía người sử dụng dẫn đến hư hỏng, móp méo, thay đổi hình dạng.
          </li>
          <li className='list-decimal border-t border-hl-beige p-4'>Sản phẩm đã được sử dụng.</li>
          <li className='list-decimal border-t border-hl-beige p-4'>Sản phẩm được mua quá 10 ngày từ khi sản phẩm được bán ra.</li>
        </ul>
        <p className='font-medium italic'>
          * Chúng tôi không chấp nhận <strong>trả lại hàng, hoàn lại tiền</strong> với các trường hợp muốn trả lại hàng vì{' '}
          <strong>lý do cá nhân như không nữa, thay đổi ý định hay các lý do cá nhân khác</strong>.
        </p>
      </div>
    </div>
  );
};
